import { supabase } from '../services/supabaseClient';

export async function agregarEmpresa(nuevaEmpresa) {
  const { data, error } = await supabase
    .from('empresas')
    .insert([nuevaEmpresa])
    .select();

  if (error) throw error;
  return data[0];
}

export async function obtenerEmpresas() {
  const { data, error } = await supabase
    .from('empresas')
    .select('*')
    .order('creado_en', { ascending: false });

  if (error) throw error;
  return data;
}